import React, { useState, useEffect } from "react";
import axios from "axios";
import '@fortawesome/fontawesome-free/css/all.min.css';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import ReactDOMServer from "react-dom/server";

const EditableCards_njadhav = ({ customerData, CompanyId, userid, animal, bookdate, ShowCustomerMasterRates, LinemanMilkStockData, centername, usernameglobal }) => {
  
  const [searchKeyword, setSearchKeyword] = useState("");
  const [filteredCustomerData, setFilteredCustomerData] = useState(customerData);
  const [inputValues, setInputValues] = useState({});

  const apireq05042024 = process.env.REACT_APP_SERVER_API_URL+"/";
  const MySwal = withReactContent(Swal);
  
  useEffect(() => {
    setFilteredCustomerData(
      customerData.filter((customer) =>
        customer.customer_name.toLowerCase().includes(searchKeyword.toLowerCase())
      )
    );
  }, [searchKeyword, customerData]);

  const handleInputChange = (customerId, field, value) => {
    if (value === "" || /^\d*\.?\d*$/.test(value)) {
      setInputValues((prev) => ({
        ...prev,
        [customerId]: {
          ...prev[customerId],
          [field]: value,
        },
      }));
    }
  };
  
  const handleBlur = (customerId, field) => {
    setInputValues((prev) => ({
      ...prev,
      [customerId]: {
        ...prev[customerId], // Ensure the customerId key exists
        [field]: Number(prev[customerId]?.[field] || 0).toFixed(2), // Safely access the field
      },
    }));
  };  

  const ShortEdit = async (event, customer) => {
    event.preventDefault();

    // const updatedCowQty = inputValues[customer.customer_mp_id]?.cowqty || customer.cowqty;
    // const updatedBuffQty = inputValues[customer.customer_mp_id]?.buffqty || customer.buffqty;
    
    const updatedCowQty = inputValues[customer.customer_mp_id]?.cowqty ||
    customer.cowqty ||
    (ShowCustomerMasterRates ? customer.cowqty_customer_master : "") ||
    "";

    const updatedBuffQty = inputValues[customer.customer_mp_id]?.buffqty ||
    customer.buffqty ||
    (ShowCustomerMasterRates ? customer.buffqty_customer_master : "") ||
    "";

    const payload = {
      CompanyId,
      userid,
      tran_date: new Date().toISOString().split("T")[0], //current date is 13 8 2025 still gettin passed 12 8 2025
      // tran_date: bookdate,
      transactionid: customer.transaction_id,
      customer_mp_id: customer.customer_mp_id,
      cowqty: updatedCowQty,
      buffqty: updatedBuffQty,
      cowrate: customer.cowrate,
      buffrate: customer.buffrate,
      centerid: customer.centerid,
      routename: customer.routename,
      customer_centerwiseid: customer.customer_centerwiseid,
      customer_name: customer.customer_name,
      customer_place: customer.customer_place,
      customer_mobile: customer.customer_mobile,
      productsale_amt: inputValues[customer.customer_mp_id]?.productsale_amt ? inputValues[customer.customer_mp_id]?.productsale_amt : ""
    };
    // console.log(payload);return;
    try {
      const response = await axios.post(
        payload.transactionid !== undefined
          ? apireq05042024 + "DailyDeliverySheet_njadhav/ShortEdit"
          : apireq05042024 + "DailyDeliverySheet_njadhav/insert",
        payload
      );

      if (response.status === 200) {

        if (response.data === "Successfully Updated" || response.data.message === "Successfully inserted") {
          MySwal.fire({
            html: <b>{response.data === "Successfully Updated" ? "Record updated successfully" : "Record inserted successfully"}</b>,
            icon: "success",
          });
          setFilteredCustomerData((prev) =>
            prev.map((item) =>
              item.customer_mp_id === customer.customer_mp_id
                ? {
                    ...item,
                    cowqty: Number(updatedCowQty) > 0.0001 ? updatedCowQty : item.cowqty,
                    buffqty: Number(updatedBuffQty) > 0.0001 ? updatedBuffQty : item.buffqty,
                    productsale_amt: Number(payload.productsale_amt) > 0.0001 ? payload.productsale_amt : item.productsale_amt,
                    transaction_id: response.data.new_transaction_id || item.transaction_id,
                  }
                : item
            )
          );          
          setInputValues((prev) => ({ //Chatgpt, Why setInputValues values used here? Explain the code.
            ...prev,
            [customer.customer_mp_id]: {},
          }));

        }
        else if (response.data == "Record deleted successfully."){
          MySwal.fire({
            html: <b>{"Record deleted successfully"}</b>,
            icon: "success",
          });

          // Update the state for FilteredCustomerData to reset values for deleted record
          setFilteredCustomerData((prev) =>
            prev.map((item) =>
              item.customer_mp_id === customer.customer_mp_id
                ? {
                    ...item,
                    // Reset values for deleted record
                    cowqty: "",
                    buffqty: "",
                    productsale_amt: "",
                    transaction_id: null, // Remove the transaction ID
                  }
                : item
            )
          );

          setInputValues((prev) => ({
            ...prev, // Keep the existing input values for other customers
            [customer.customer_mp_id]: {}, // Reset the input values for the specific customer to an empty object
          }));
        }
        else {
          MySwal.fire({
            html: <b>{JSON.stringify(response.data)}</b>,
            icon: "warning",
          });
        }
      }
    } catch (error) {
      MySwal.fire({
        html: <b>Please input required fields</b>,
        icon: "error",
      });
    }
  };

  const MonthlySalesTransactionReportForLineMan = async (event, customer, bookdate) => {
    event.preventDefault();

    const payload = {
      CompanyId,
      userid,
      tran_date: bookdate,
      customer_mp_id: customer.customer_mp_id,
      centerid: customer.centerid,
      routename: customer.routename,
      customer_centerwiseid: customer.customer_centerwiseid,
      customer_name: customer.customer_name,
      customer_place: customer.customer_place,
      customer_mobile: customer.customer_mobile,
    };
    
    try {          
                
      // Reset report data before fetching new data
      setCustomerDataPrint([]);
      setDataLoaded(false);

      MySwal.fire({
        title: 'Generating Report',
        text: 'Please wait while the report is being generated.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      const response = await axios.post(
          apireq05042024 + "DailyDeliverySheet_njadhav/MonthlySalesTransactionReportForLineMan",
          payload
      );

      if (response.status === 200) {
        if(response.data.length >0) {
          MySwal.close();
          setCustomerDataPrint(response.data);  
          setDataLoaded(true); 
        }   
        else{
          setCustomerDataPrint(sampledata);
        }
      }
    } catch (error) {
      MySwal.fire({
        html: <b>Please input required fields</b>,
        icon: "error",
      });
    }
  };

  const sampledata = [
    { customer_centerwiseid: 1, customer_name: 'Alice', days: ['', '', '', '', '', '', '', '', '', '','', '', '', '', '','', '', '', '', '', '', '', '', '', '','', '', '', '', '', ''] },
    { customer_centerwiseid: 2, customer_name: 'Bob', days: ['', '', '', '', '', '', '', '', '', '','', '', '', '', '','', '', '', '', '', '', '', '', '', '','', '', '', '', '', ''] },
  ];

  const [CustomerDataPrint, setCustomerDataPrint] = useState(sampledata);

  const [dataLoaded, setDataLoaded] = useState(false);

  useEffect(() => {
    if (dataLoaded) {
      printContent();
    }
  }, [dataLoaded]);

  async function printContent() {
    
    try {
        // Dynamically import the corresponding bill format component
        const BillFormat = await import(`./reports/MonthlySalesTransactionReportForLineMan.jsx`);
       
        // Generate the bill content as JSX
        const billComponent = (
            <BillFormat.default
                bookdate={bookdate}
                CustomerDataPrint={CustomerDataPrint}
                getMonthName={getMonthName}
                centername={centername}
                calculateTotalLiters={calculateTotalLiters}
                calculateAmount={calculateAmount}
                defaultroutename={CustomerDataPrint?.[0]?.routename}
                defaultcenter={CustomerDataPrint?.[0].centerid}
            />
        );

        // Convert JSX to an HTML string
        const billContent = ReactDOMServer.renderToString(billComponent);

        // Open a new window for printing
        const printWindow = window.open('', '_blank');
        if (!printWindow) {
            console.error("Unable to open print window.");
            return;
        }

        // Write the formatted HTML into the new window
        printWindow.document.write(`
            <!DOCTYPE html>
            <html lang="en">
              <head>
                  <meta charset="UTF-8">
                  <meta name="viewport" content="width=device-width, initial-scale=1.0">
                  <title>Milk Bill</title>          
                  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-QWTKZyjpPEjISv5WaRU9OFeRpok6YctnYmDr5pNlyT2bRjXh0JMhjY6hW+ALEwIH" crossorigin="anonymous">
                  <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/js/bootstrap.bundle.min.js" integrity="sha384-YvpcrYf0tY3lHB60NNkmXc5s9fDVZLESaAA55NDzOxhy9GkcIdslK1eN7N6jIeHz" crossorigin="anonymous"></script>
              </head>
              <style>
                  @page {
                      size: A4;
                      margin: 0;
                  }

                  body {
                      margin: 0;
                      padding: 0;
                      font-family: Arial, sans-serif;
                  }

                  .bill_printmonthlybill {
                      width: 8.5in;
                      height: 5.75in; /* Adjusted height for two per page */
                      border: 1px solid #000;
                      margin-bottom: 10px;
                      padding: 5px;
                      box-sizing: border-box;
                      page-break-inside: avoid;
                      display: flex;
                      flex-direction: column;
                      justify-content: space-between;
                  }

                  .info_printmonthlybill {
                      display: flex;
                      justify-content: space-between;
                      font-size: 12px;
                  }

                  .content_printmonthlybill {
                      display: flex;
                      justify-content: space-between;
                  }

                  .section_printmonthlybill {
                      width: 32%;
                      border: 1px solid #000;
                      padding: 5px;
                      box-sizing: border-box;
                      margin-bottom: 10px; /* Added margin-bottom for gap */
                  }
                  
                  .section_printmonthlybill {
                    width: 32%;
                    border: 1px solid #000;
                    padding: 5px;
                    box-sizing: border-box;
                  }

                  .calendar_printmonthlybill table {
                      width: 100%;
                      border-collapse: collapse;
                      table-layout: fixed;
                      font-size: 10px;
                  }

                  .calendar_printmonthlybill th, .calendar_printmonthlybill td {
                      border: 1px solid #000;
                      text-align: center;
                      padding: 2px;
                      vertical-align: top;
                      height: 25px;
                  }

                  .summary_printmonthlybill, .notes_printmonthlybill {
                      font-size: 12px;
                      text-align: left;             
                  }

                  @media print {
                      body {
                          margin: 0;
                      }

                      .bill_printmonthlybill {
                          page-break-inside: avoid;
                          break-inside: avoid;
                      }
                  }
              </style>
            <body>
                ${billContent}
            </body>
            </html>
        `);

        printWindow.document.close();
        //printWindow.print();
    } catch (error) {
        console.error(`Error loading bill format for owner`, error);
        alert("Unable to load bill format. Please contact support.");
    }
  }

  function calculateTotalLiters(days) {
      let total = 0;
      for (let day in days) {
          if (days[day]) {
              total += parseFloat(days[day]);
          }
      }
      return total;
  }
  
  function calculateAmount(days, rate = null) {
    // console.log(rate);

    const pricePerLiter = Number(rate);
    // console.log(calculateTotalLiters(days) * pricePerLiter);
    return calculateTotalLiters(days) * pricePerLiter;
    
  }
  
  function getMonthName(monthNumber) {
    const monthNames = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];
    return monthNames[monthNumber - 1]; // Subtract 1 because array index starts at 0
  }

  return (
    <div>
      <div className="row mb-3">
      {Array.isArray(LinemanMilkStockData) && (
          <>
            {/* Cow Qty Section */}
            <div className="col-6 mb-3">
              <div
                className="p-4 bg-yellow-100 border border-yellow-300 rounded-2xl shadow-md"
                style={{
                  borderRadius: "16px",
                  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                  backgroundColor: "#e6ffe6",
                }}
              >
                <h2 className="text-center text-lg font-semibold mb-4">Cow Qty</h2>
                <div className="text-sm">
                  <p className="mb-2">
                    <strong>Op Qty:</strong>{" "}
                    {Number(LinemanMilkStockData?.[0]?.cow_given_qty || 0).toFixed(2)}
                  </p>
                  <p className="mb-2">
                    <strong>Sold Qty:</strong>{" "}
                    {filteredCustomerData
                      .reduce(
                        (total, customer) => total + Number(customer.cowqty || 0),
                        0
                      )
                      .toFixed(2)}
                  </p>
                  <p>
                    <strong>Cl Qty:</strong>{" "}
                    {(
                      Number(LinemanMilkStockData?.[0]?.cow_given_qty || 0) -
                      filteredCustomerData.reduce(
                        (total, customer) => total + Number(customer.cowqty || 0),
                        0
                      )
                    ).toFixed(2)}
                  </p>
                </div>
              </div>
            </div>

            {/* Buff Qty Section */}
            <div className="col-6 mb-3">
              <div
                className="p-4 bg-yellow-100 border border-yellow-300 rounded-2xl shadow-md"
                style={{
                  borderRadius: "16px",
                  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                  backgroundColor: "#e6ffe6",
                }}
              >
                <h2 className="text-center text-lg font-semibold mb-4">Buff Qty</h2>
                <div className="text-sm">
                  <p className="mb-2">
                    <strong>Op Qty:</strong>{" "}
                    {Number(LinemanMilkStockData?.[0]?.buff_given_qty || 0).toFixed(2)}
                  </p>
                  <p className="mb-2">
                    <strong>Sold Qty:</strong>{" "}
                    {filteredCustomerData
                      .reduce(
                        (total, customer) => total + Number(customer.buffqty || 0),
                        0
                      )
                      .toFixed(2)}
                  </p>
                  <p>
                    <strong>Cl Qty:</strong>{" "}
                    {(
                      Number(LinemanMilkStockData?.[0]?.buff_given_qty || 0) -
                      filteredCustomerData.reduce(
                        (total, customer) => total + Number(customer.buffqty || 0),
                        0
                      )
                    ).toFixed(2)}
                  </p>
                </div>
              </div>
            </div>
          </>
        )}

        <div className="col-md-12">
          <input
            type="text"
            className="form-control"
            placeholder="Search by customer name..."
            value={searchKeyword}
            onChange={(e) => setSearchKeyword(e.target.value)}
          />
        </div>
      </div>

      <div className="row">
      {filteredCustomerData.map((customer) => {
        // Check if any of the fields have a value
        const hasValues = customer.cowqty > 0.0001 || customer.buffqty > 0.0001 || customer.productsale_amt > 0.0001;
        
        return (
          <div className="col-md-4 mb-3" key={customer.customer_mp_id}>
            <div
              className="card h-100"
              style={{
                boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                backgroundColor: hasValues ? "#e6ffe6" : "white", // Highlight card with a light green background
                border: hasValues ? "2px solid #28a745" : "none", // Add a green border for highlighted cards
              }}
            >
              <div className="card-body">
                <h5 className="card-title">
                  {customer.customer_name}
                  <i
                    className="fa-solid fa-phone"
                    style={{
                      marginLeft: "10px",
                      marginRight: "5px",
                      color: "#007bff",
                      cursor: "pointer",
                    }}
                  ></i>
                  - <a href={`tel:${customer.customer_mobile}`}>{customer.customer_mobile}</a>

                  {/* Tick mark if any value exists */}
                  {hasValues && (
                    <i
                      className="fa-solid fa-check-circle"
                      style={{
                        marginLeft: "10px",
                        color: "#28a745", // Green tick
                      }}
                    ></i>
                  )}
                
                  <i
                    className="fa-solid fa-calendar-alt"
                    style={{
                      fontSize: "20px",
                      marginLeft: "20px",
                      color: "#007bff",
                      cursor: "pointer",
                    }}
                    onClick={(e) => MonthlySalesTransactionReportForLineMan(e, customer, bookdate)}
                  ></i>
                  

              </h5>

                {/* Form Inputs */}
                <div className="form-group">
                  <div className="row align-items-center">
                    {/* Cow Qty */}
                    <div className="col-3">
                      <label htmlFor={`label-cowqty-${customer.customer_mp_id}`}>Cow Qty</label>
                      <input
                        type="number"
                        className="form-control"
                        value={
                          // Priority 1: If the user has modified the value, use it and ensure it's a valid number
                          inputValues[customer.customer_mp_id]?.cowqty !== undefined
                            ? Number(inputValues[customer.customer_mp_id].cowqty || 0)
                            : 
                          // Priority 2: Use the existing `cowqty` value from the customer object, ensuring it's valid
                          customer.cowqty !== undefined
                            ? Number(customer.cowqty || 0)
                            : 
                          // Priority 3: If `ShowCustomerMasterRates` is true, use the `cowqty_customer_master` value
                          ShowCustomerMasterRates
                            ? Number(customer.cowqty_customer_master || 0)
                            : 
                          // Default: Use an empty string if none of the above conditions are met
                          ""
                        }
                        // Update the input value in `inputValues` when the user types
                        onChange={(e) =>
                          handleInputChange(customer.customer_mp_id, "cowqty", e.target.value)
                        }
                        onBlur={() => handleBlur(customer.customer_mp_id, "cowqty")}
                      />
                    </div>

                    {/* Buff Qty */}
                    <div className="col-3">
                      <label htmlFor={`label-buffqty-${customer.customer_mp_id}`}>Buff Qty</label>
                      <input
                        type="number"
                        className="form-control"
                        value={
                          // Priority 1: If the user has modified the value, use it and ensure it's a valid number
                          inputValues[customer.customer_mp_id]?.buffqty !== undefined
                            ? Number(inputValues[customer.customer_mp_id].buffqty || 0)
                            : 
                          // Priority 2: Use the existing `buffqty` value from the customer object, ensuring it's valid
                          customer.buffqty !== undefined
                            ? Number(customer.buffqty || 0)
                            : 
                          // Priority 3: If `ShowCustomerMasterRates` is true, use the `buffqty_customer_master` value
                          ShowCustomerMasterRates
                            ? Number(customer.buffqty_customer_master || 0)
                            : 
                          // Default: Use an empty string if none of the above conditions are met
                          ""
                        }
                        // Update the input value in `inputValues` when the user types
                        onChange={(e) =>
                          handleInputChange(customer.customer_mp_id, "buffqty", e.target.value)
                        }
                        onBlur={() => handleBlur(customer.customer_mp_id, "buffqty")}
                      />
                    </div>


                    {/* Other Amt */}
                    <div className="col-3">
                      <label htmlFor={`label-productsale_amt-${customer.customer_mp_id}`}>Other Amt</label>
                      <input
                        type="number"
                        className="form-control"
                        value={
                          inputValues[customer.customer_mp_id]?.productsale_amt ??
                          customer.productsale_amt ?? // Fallback to customer value
                          "" // Default to an empty string
                        }
                        onChange={(e) =>
                          handleInputChange(customer.customer_mp_id, "productsale_amt", e.target.value)
                        }
                        onBlur={() => handleBlur(customer.customer_mp_id, "productsale_amt")}
                      />
                    </div>

                    {/* Save Button */}
                    <div className="col-3 text-right">
                      <button
                        className="btn btn-primary mt-4"
                        onClick={(e) => ShortEdit(e, customer)}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })}

    </div>

    </div>
  );
};

export default EditableCards_njadhav;
